export const STARTING_LEVEL = 1;

type IEntry = { hp: number; damage: number; cost: number };

export const enemyRecord: Record<string, IEntry> = {
  cat: { hp: 4, damage: 2, cost: 0 },
  bird: { hp: 6, damage: 3, cost: 0 },
};
export const dropRecord: Record<string, IEntry> = {
  apple: { hp: 15, damage: 0, cost: 0 },
  dagger: { hp: 0, damage: 1, cost: 0 },
  "bad-banana": { hp: -10, damage: 0, cost: 0 },
};
